(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grise-preorder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('grise-preorder')) {
    customElements.define('grise-preorder', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.update(this.dataset.selectedId);
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const sectionId = this.productInfo?.dataset.originalSection || this.productInfo?.dataset.section;
            if (String(data.sectionId) === String(sectionId)) this.update(data.variant?.id);
          });
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      update(variantId) {
        const preorder = this.dataset.variantIds.split(',').includes(String(variantId));
        this.querySelector('.grise-preorder__notice').hidden = !preorder;
        const button = this.closest('product-form')?.querySelector('button[name="add"]');
        if (button && !button.disabled) {
          const label = button.querySelector('span');
          if (label) label.textContent = preorder ? this.dataset.buttonLabel : this.dataset.cartLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
